/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAutotaskCompaniesRequest
 */
export interface GetAutotaskCompaniesRequest {
    /**
     * Optional API user name to use (uses the stored one if not provided)
     */
    apiUserName?: string;
    /**
     * Optional API secret to use (uses the stored secret if not provided)
     */
    secret?: string;
}

/**
 * Check if a given object implements the GetAutotaskCompaniesRequest interface.
 */
export function instanceOfGetAutotaskCompaniesRequest(value: object): value is GetAutotaskCompaniesRequest {
    return true;
}

export function GetAutotaskCompaniesRequestFromJSON(json: any): GetAutotaskCompaniesRequest {
    return GetAutotaskCompaniesRequestFromJSONTyped(json, false);
}

export function GetAutotaskCompaniesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutotaskCompaniesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'apiUserName': json['apiUserName'] == null ? undefined : json['apiUserName'],
        'secret': json['secret'] == null ? undefined : json['secret'],
    };
}

export function GetAutotaskCompaniesRequestToJSON(json: any): GetAutotaskCompaniesRequest {
    return GetAutotaskCompaniesRequestToJSONTyped(json, false);
}

export function GetAutotaskCompaniesRequestToJSONTyped(value?: GetAutotaskCompaniesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiUserName': value['apiUserName'],
        'secret': value['secret'],
    };
}

